import * as React from 'react'
import {
  Button,
  Link,
  Typography,
  IconButton,
  Paper,
  Box,
  Switch,
  TextField
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import dayjs, { Dayjs } from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import ReportsTable from '../../components/ReportsTable'
import { createEffect, createStore } from 'effector'
import api from '../../Auth/api'

import { useForm } from 'react-hook-form'
import { useStore } from 'effector-react'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'

export const $reportsTable = createStore(null)

export const getReportsTableFx = createEffect(async (data) => {
  const response = api.post(`paid-service/task-report`, data)
  return response
})

$reportsTable.on(getReportsTableFx, (state) => {
  return {
    ...state
  }
})

$reportsTable.on(getReportsTableFx.done, (state, { result }) => {
  return {
    ...state,
    data: result.data.data
  }
})

$reportsTable.on(getReportsTableFx.fail, (state, { error }) => {
  return {
    ...state
  }
})

export default function StageReports() {
  const [state, setState] = React.useState('unfinished')
  const [minDate, setMinDate] = React.useState(dayjs())
  const [maxDate, setMaxDate] = React.useState(dayjs())
  const [checked, setChecked] = React.useState(false)
  const reportsTable = useStore($reportsTable)
  const handleChange = (event) => {
    setChecked(event.target.checked)
    if (event.target.checked) {
      setState('finished')
      return
    }
    setState('unfinished')
    return
  }
  React.useEffect(() => {
    const min = minDate?.format ? minDate.format('YYYY-MM-DD') : minDate
    const max = maxDate?.format ? maxDate.format('YYYY-MM-DD') : maxDate
    const data = {
      state: state,
      createdAt: {
        min: min,
        max: max
      }
    }
    getReportsTableFx(data)
  }, [state, minDate, maxDate])
  return (
    <>
      <Paper
        sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }}
        elevation={0}
      >
        <Box display="flex" flexDirection="column">
          <BlockTitle
            label={'Кол-во выполненных стадий по сотрудникам'}
            backUrl="/reports"
          />
          <Box display="flex" mt={2} mb={2} alignItems="center">
            <Typography variant="subtitle1">Задания в работе</Typography>
            <Switch
              sx={{ ml: 2, mr: 2 }}
              checked={checked}
              onChange={handleChange}
            />
            <Typography variant="subtitle1">Выполненные задания</Typography>
            <Typography ml={10} mr={1} variant="subtitle1">
              Выберите период:
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                inputFormat="DD.MM.YYYY"
                label="С"
                value={minDate}
                onChange={(newValue) => {
                  setMinDate(
                    newValue?.format ? newValue.format('YYYY-MM-DD') : newValue
                  )
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Typography pr={2} pl={2} variant="subtitle2">
              -
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                inputFormat="DD.MM.YYYY"
                label="По"
                value={maxDate}
                onChange={(newValue) => {
                  setMaxDate(
                    newValue?.format ? newValue.format('YYYY-MM-DD') : newValue
                  )
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
          <ReportsTable reportsTable={reportsTable} />
        </Box>
      </Paper>
    </>
  )
}
